import { t } from "@/i18n-js/instance";

export const CIRCLE_KB_URL = "https://help.circle.so";
export const CIRCLE_COMMUNITY_WHATS_NEW_URL =
  "https://community.circle.so/c/product-updates";

export const CIRCLE_ACADEMY_URL =
  "https://circle-academy.circle.so/c/start-here/";
export const CIRCLE_COMMUNITY_URL = "https://community.circle.so/feed";
export const CIRCLE_PARTNERS_URL = "https://circle.so/partner-directory";
export const CIRCLE_COMMUNITY_LIVE_EVENTS =
  "https://community.circle.so/c/live-events/";

export const HELP_WIDGET_IS_OPEN_LOCAL_STORAGE_KEY = "help-widget-is-open";
export const HELP_WIDGET_IS_EXPANDED_LOCAL_STORAGE_KEY =
  "help-widget-is-expanded";
export const HELP_WIDGET_IS_SIDEBAR_OPEN_LOCAL_STORAGE_KEY =
  "help-widget-is-sidebar-open";
export const HELP_WIDGET_FAB_VISIBLE_LOCAL_STORAGE_KEY =
  "help-widget-fab-visible";
export const HELP_WIDGET_DRAFT_CONVERSATION_ID_LOCAL_STORAGE_KEY =
  "help-widget-draft-conversation-id";
export const HELP_WIDGET_VIRTUAL_MESSAGES_LOCAL_STORAGE_KEY =
  "help-widget-virtual-messages";
export const HELP_WIDGET_VIRTUAL_CONVERSATION_TYPE_LOCAL_STORAGE_KEY =
  "help-widget-virtual-conversation-type";

export const VIRTUAL_CONVERSATION_ID = "virtual";

export const WIDGET_HIDDEN_ROUTES = [
  "/messages/new",
  "/messages",
  "/live",
  "/workflows/edit",
  "/workflows/new",
  "/workflows/view",
  "/discover",
  "/settings/branded_apps_builder_ui",
  "/settings/pages/edit",
] as const;

export const SUPPORT_WIDGET_DEFAULT_TRANSITIONS = {
  enter: "transition ease-out duration-200 transform",
  enterFrom: "opacity-0 scale-95",
  enterTo: "opacity-100 scale-100",
  leave: "transition ease-in duration-200 transform",
  leaveFrom: "opacity-100 scale-100",
  leaveTo: "opacity-0 scale-95",
} as const;

export const FIVE_MINUTES = 5 * 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;
export const ONE_HOUR = 60 * 60 * 1000;
export const ONE_YEAR = 365 * 24 * 60 * 60 * 1000;

export const ATTACHMENT_STATUS_COMPLETED = "completed" as const;
export const ATTACHMENT_STATUS_FAILED = "failed" as const;
export const ATTACHMENT_STATUS_UPLOADING = "uploading" as const;

export const ATTACHMENT_FILENAME_LENGTH = {
  COMPLETED: 40,
  UPLOADING: 28,
} as const;

export const TICKET_TYPES = [
  { text: t("support_widget.constants.bug"), value: "bug" },
  { text: t("support_widget.constants.feedback"), value: "feedback" },
  { text: t("support_widget.constants.question"), value: "question" },
] as const;

export const TICKET_PRIORITIES = [
  {
    text: t(
      "support_widget.constants.ticket_priorities.i_have_a_question_or_feedback",
    ),
    value: "low_i_have_a_question_or_feedback",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_non_critical_issue_is_slowing_me_down",
    ),
    value: "low_a_non_critical_issue_is_slowing_me_down",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_critical_issue_is_impacting_some_members_of_my_community",
    ),
    value: "high_a_critical_issue_is_impacting_some_members_of_my_community",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_member_or_admin_cannot_access_their_account",
    ),
    value: "urgent_a_member_or_admin_cannot_access_their_account",
  },
  {
    text: t(
      "support_widget.constants.ticket_priorities.a_major_feature_does_not_work_for_my_community",
    ),
    value: "urgent_a_major_feature_does_not_work_for_my_community",
  },
] as const;

export const CONVERSATION_TYPES = [
  {
    text: t("help_widget.constants.conversations.types.all"),
    value: "all",
  },
  {
    text: t("help_widget.constants.conversations.types.copilot"),
    value: "circle_bot",
  },
  {
    text: t("help_widget.constants.conversations.types.live_chat"),
    value: "live_chat",
  },
  {
    text: t("help_widget.constants.conversations.types.email"),
    value: "email",
  },
] as const;

export const CONVERSATION_STATUSES = [
  {
    text: t("help_widget.constants.conversations.statuses.all"),
    value: "all",
  },
  {
    text: t("help_widget.constants.conversations.statuses.draft"),
    value: "draft",
  },
  {
    text: t("help_widget.constants.conversations.statuses.open"),
    value: "open",
  },
  {
    text: t("help_widget.constants.conversations.statuses.solved"),
    value: "solved",
  },
  {
    text: t("help_widget.constants.conversations.statuses.closed"),
    value: "closed",
  },
] as const;
